import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Label, Tooltip, Button, Spinner,Row,Col } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";
import CustomSelect from "../../../../../helpers/ui/CustomSelect";
import DetailBloc from "../Blocs/DetailBloc";
import apiResponse from "../../../../../services/apiResponse";
import { Link } from "react-router-dom";
import Shimmer from "react-shimmer-effect";
import ReactTimeAgo from "react-time-ago";
import {
  AvForm
} from "availity-reactstrap-validation";

class TableComponentNew extends Component {
  detailBloc = new DetailBloc();

  source;
  historyTable = "TableEmployeeMapping";
  defaultOrder = "employee_name"; // orderBy
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      periodUuid: null,
      inactiveUuid: null,
      chartUuid: null,
      chart2Uuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: false,
      filterjabatan : null,
      sessWorkunit : null,
      isfilterreset : false,
      loadingoptions : false,
      downloadingFile: false,
      optionfilter  : [],
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }

  LoadingState = () => (
    <div
        style={{
        padding: "80px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        }}
    >
        <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
        <h5 className="mt-4 text-muted">Mengambil data...</h5>
    </div>
    );
    
      
    EmptyState = () => (
    <div
        style={{
        padding: "80px 0",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#6c757d"
        }}
    >
        {/* <img
        src="/no-data.png"  // ganti dengan gambar yang kamu punya
        alt="Tidak ada data"
        style={{ width: "180px", opacity: 0.8 }}
        /> */}
        <h5 className="mt-4">Tidak ada data</h5>
        {/* <p className="text-muted mb-0" style={{ maxWidth: "300px" }}>
        Data tidak ditemukan. Periksa kembali input atau coba muat ulang.
        </p> */}
    </div>
    );

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );
    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      workunit_uuid: this.props.work_unit,
      // workunit_uuid: this.props.filter.work_unit_uuid,
      position_uuid : this.state.filterjabatan || this.props.position_uuid || '',
      period_uuid: this.props.periode,
    };
    await this.detailBloc.fetchListEmployee(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  onChangeFilter = (value) => {
    if (this.state.filterjabatan == null) {
      this.setState({ filterjabatan: value }, () => this.setTokenAPI());
    } else {
      this.setState({ filterjabatan: null }, () => this.setTokenAPI());
    }
  };
  

 componentDidMount() {
    this.detailBloc.employeeListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({ loadingTable: false });
          break;
        case apiResponse.LOADING:
          this.setState({ loadingTable: true });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          let optionfilter = this.state.optionfilter;
          let newState = {
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
            optionfilter: optionfilter,
            filterjabatan: this.state.isfilterreset ? null : this.state.filterjabatan,
            isfilterreset: false,
          };
          
          if (this.state.isfilterreset) {
            optionfilter = [
              { label: "Pilih semua jabatan", value: null },
              ...response.result
                .map((item) => ({
                  label: item.employee_current_position_name,
                  value: item.employee_current_position_uuid,
                }))
                .filter(
                  (v, i, a) => a.findIndex((t) => t.value === v.value) === i
                ),
            ];
            newState.optionfilter = optionfilter;
            newState.loadingoptions = false;
          }
          this.setState(newState);
          break;
        case apiResponse.ERROR:
          let errorState = { loadingTable: false };
          
          if (this.state.isfilterreset) {
            errorState.loadingoptions = false;
          }
          
          this.setState(errorState);
          break;
        default:
          break;
      }
    });
    this.detailBloc.fetchexportDataNewPetajabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({ downloadingFile: true });
          break;
          
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            if (response.file_url) {
              //window.open(response.file_url, '_blank');
              const link = document.createElement('a');
              link.href = response.file_url;
              link.download = response.file_url.split('/').pop(); // ambil nama file dari URL
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            
            this.setState({ downloadingFile: false });
          } else {
            // Handle jika status false
            ConfirmAlert({
              title: 'Gagal',
              desc: result.data.message || 'Gagal mengunduh file',
              isCancel: false,
              confirmBtnText: 'OK'
            });
            this.setState({ downloadingFile: false });
          }
          break;
          
        case apiResponse.ERROR:
          // Tampilkan error message
          ConfirmAlert({
            title: 'Error',
            desc: 'Terjadi kesalahan saat mengunduh file',
            isCancel: false,
            confirmBtnText: 'OK'
          });
          this.setState({ downloadingFile: false });
          break;
          
        default:
          break;
      }
    });
  }
  
  // componentDidUpdate(prevProps, prevState) {

  //   if (this.props.work_unit && this.props.work_unit !== prevProps.work_unit) {
  //     this.setState(
  //       {
  //         loadingoptions: true,
  //         sessWorkunit: this.props.work_unit,
  //         isfilterreset: true,
  //         filterjabatan: null,
  //       },
  //       () => this.setTokenAPI()
  //     );
  //   }
  // }

  componentDidUpdate(prevProps) {
    const workUnitChanged = this.props.work_unit !== prevProps.work_unit;
    const positionChanged = this.props.position_uuid !== prevProps.position_uuid;
    if (workUnitChanged || positionChanged) {
      this.setState(
        {
          loadingoptions: true,
          sessWorkunit: this.props.work_unit,
          position_uuid : this.props.position_uuid,
          isfilterreset: true,
          filterjabatan: null,
        },
        () => this.setTokenAPI()
      );
    }
  }

  handleButtonRekapExport = async() => {
    await this.detailBloc.fetchexportDataNewPetajabatan({
      uuid_work_unit : this.props.work_unit,
      uuid_position : this.state.filterjabatan,
      period_uuid : this.props.periode
    })
  }

  componentWillUnmount() {
    this.detailBloc.listChannel?.unsubscribe();
  }

  columns = [
    
    {
      key: "employee_nip",
      text: "Nip",
      sortable: false,
    },
    {
      key: "employee_name",
      text: "Nama",
      sortable: false,
    },
    // {
    //   key: "kedudukan_hukum",
    //   text: "Kedudukan Hukum",
    //   sortable: false,
    // },
    {
      key: "rank_name",
      text: "Golongan",
      sortable: false,
    },
    {
      key: "employee_current_position_name",
      text: "Jabatan",
      sortable: false,
    },

    // {
    //   key: "action",
    //   text: "Action",
    //   className: "action",
    //   width: 120,
    //   sortable: false,
    //   align: "center",
    //   cell: (record) => {
    //     const thisId = record.position_mapping_id;
    //     return (
    //       <Fragment>
    //         {/* { record.echelon_code > 10 && record.echelon_code < 30 &&  */}
    //         <Fragment>
    //           <span>
    //             <button
    //               className="btn btn-warning btn-sm"
    //               style={{ marginRight: "2px", padding: "2px 5px" }}
    //               id={"edit" + thisId}
    //               onClick={() => {
    //                 this.setState({
    //                   updateUuid: record.position_mapping_uuid,
    //                   periodUuid: record.position_mapping_period_uuid,
    //                 });
    //               }}
    //             >
    //               <i className="uil-pen"></i>
    //             </button>
    //             <Tooltip
    //               style={{ marginBottom: "2px" }}
    //               placement="top"
    //               isOpen={this.state["edit" + thisId]}
    //               target={"edit" + thisId}
    //               toggle={() => {
    //                 this.setState({
    //                   ["edit" + thisId]: !this.state["edit" + thisId],
    //                 });
    //               }}
    //             >
    //               Edit KP
    //             </Tooltip>
    //           </span>
    //           {/* <span>
    //             <button
    //               className="btn btn-primary btn-sm"
    //               style={{ marginRight: "2px", padding: "2px 5px" }}
    //               id={"chart2" + thisId}
    //               onClick={() => {
    //                 this.setState({
    //                   chart2Uuid: record.position_mapping_work_unit_uuid,
    //                   periodUuid: record.position_mapping_period_uuid,
    //                 });
    //               }}
    //             >
    //               <i className="uil-game-structure"></i>
    //             </button>
    //             <Tooltip
    //               style={{ marginBottom: "2px" }}
    //               placement="top"
    //               isOpen={this.state["chart2" + thisId]}
    //               target={"chart2" + thisId}
    //               toggle={() => {
    //                 this.setState({
    //                   ["chart2" + thisId]: !this.state["chart2" + thisId],
    //                 });
    //               }}
    //             >
    //               Chart & Pegawai
    //             </Tooltip>
    //           </span> */}
    //           {/* <span>
    //             <button
    //               className="btn btn-primary btn-sm"
    //               style={{ marginRight: "2px", padding: "2px 5px" }}
    //               id={"chart" + thisId}
    //               onClick={() => {
    //                 this.setState({
    //                   chartUuid: record.position_mapping_work_unit_uuid,
    //                   periodUuid: record.position_mapping_period_uuid,
    //                 });
    //               }}
    //             >
    //               <i className="uil-game-structure"></i>
    //             </button>
    //             <Tooltip
    //               style={{ marginBottom: "2px" }}
    //               placement="top"
    //               isOpen={this.state["chart" + thisId]}
    //               target={"chart" + thisId}
    //               toggle={() => {
    //                 this.setState({
    //                   ["chart" + thisId]: !this.state["chart" + thisId],
    //                 });
    //               }}
    //             >
    //               Chart ABK
    //             </Tooltip>
    //           </span> */}
    //         </Fragment>
    //         {/* } */}
    //       </Fragment>
    //     );
    //   },
    // },
  ];

  render() {
    // if (this.state.loadingTable) {
    //   return this.LoadingState();
    // }
    // else{}
    // if (!this.state.loadingTable && this.state.rows.length === 0) {
    //   console.log('loading')
    //   console.log(this.state.loadingTable)
    //   console.log('rows')
    //   console.log(this.state.rows.length)
    //     return this.EmptyState();
    // }    

    return (

      <Fragment>
          {/* <div className="float-end"> */}
              {/* {
                  (accessRole('create')) ? */}
                     <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                      >
                        <Row className="mb-3">
                          <Col md="5">
                          {
                              this.state.loadingoptions ? 
                                <Shimmer>
                                  <div style={{ width: "80%", height: 40 }}></div>
                                </Shimmer>
                                :
                                <Button
                                  color="success"
                                  type="button"
                                  onClick={() => {
                                    this.handleButtonRekapExport();
                                  }}
                                  disabled={this.state.downloadingFile}
                                >
                                  {this.state.downloadingFile ? (
                                      <>
                                        <Spinner size="sm" /> Mengunduh...
                                      </>
                                    ) : (
                                        <><i className="uil-file-download-alt"></i> Unduh Data Pegawai</>
                                    )}
                                </Button>
                          }
                          </Col>
                          <label htmlFor="no_sk" className="col-md-2 col-form-label">
                            
                          </label>
                          <Col md="5">
                            {
                              this.state.loadingoptions ? 
                                <Shimmer>
                                  <div style={{ width: "80%", height: 40 }}></div>
                                </Shimmer>
                                :
                                <CustomSelect
                                  name="position_period_year"
                                  errorMessage="Pilih Jabatan"
                                  options={this.state.optionfilter}
                                  defaultValue={this.state.filterjabatan}
                                  onChange={(v) => this.onChangeFilter(v.value)}
                                  placeholder="Pilih Jabatan"
                                />
                            }
                          </Col>
                    </Row>
                  </AvForm>
                  {/* : null
              } */}
              
              {/* </div> */}
              <hr />

        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        {this.state.chartUuid !== null && (
          // <Redirect to={"/kepegawaian/strukturorganisasi.html?charts&uuid=" + this.state.chartUuid} />
          <Redirect
            to={`/kepegawaian/strukturorganisasi.html?charts&uuid=${this.state.chartUuid}&period=${this.state.periodUuid}`}
          />
        )}
        {this.state.chart2Uuid !== null && (
          // <Redirect to={"/kepegawaian/strukturorganisasi.html?chartsJabatan&uuid="+this.state.chart2Uuid} />
          <Redirect
            to={`/kepegawaian/strukturorganisasi.html?chartsJabatan&uuid=${this.state.chart2Uuid}&period=${this.state.periodUuid}`}
          />
        )}

        {this.state.updateUuid !== null && (
          <Redirect
            to={`/kepegawaian/strukturorganisasi.html?edit&uuid=${this.state.updateUuid}&period=${this.state.periodUuid}`}
          />
        )}
      </Fragment>
    );
  }
}

export default TableComponentNew;
